import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

import { TreeCategory } from '@p1/libs/catalog-service';

import { generateWatchlistPreviewElementFromElement } from '../model/watchlist-preview-element/watchlist-preview-element.generators';
import { WatchlistPreviewElement } from '../model/watchlist-preview-element/watchlist-preview-element';
import { WatchlistWithChildLists } from '../model/watchlist/watchlist-with-child-lists';
import { WatchlistElementObjectType } from '../model/watchlist-element/watchlist-element-object-type.enum';
import { P1DateFormatPipe } from '../../shared/common/pipes/p1-date-format.pipe';


/**
 * Represents a List of watchlist elements
 */
@Component({
  selector: 'p1-watchlist-content-list',
  templateUrl: 'watchlist-content-list.component.html',
  styleUrls: ['watchlist-content-list.component.scss'],
  providers: [P1DateFormatPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WatchlistContentListComponent {

  @Input()
  watchlist: WatchlistWithChildLists;

  @Input()
  canRemove: boolean;

  @Input()
  canComment: boolean;

  @Input()
  categoryTreeLeaves: {[uuid: string]: TreeCategory};

  @Output()
  removeItem: EventEmitter<WatchlistPreviewElement> = new EventEmitter<WatchlistPreviewElement>();

  @Output()
  commentItem: EventEmitter<WatchlistPreviewElement> = new EventEmitter<WatchlistPreviewElement>();

  ElementType = WatchlistElementObjectType;

  /**
   * Creates the watchlist preview component
   *
   * @param _p1DatePipe
   */
  constructor(
    private _p1DatePipe: P1DateFormatPipe
  ) {}

  get watchlistElements() {
    let previewElements: WatchlistPreviewElement[] = [];

    if (this.watchlist?.elements) {
      previewElements = this.watchlist.elements.map(element => generateWatchlistPreviewElementFromElement(element, this.categoryTreeLeaves));
    }

    return previewElements
      .sort((elementA, elementB) => elementB.added > elementA.added ? 1 : -1)
      .map(element => {
        if (element.subtitleBelow && typeof element.subtitleBelow === 'number') {
          element.subtitleBelow = this._p1DatePipe.transform(element.subtitleBelow);
          return element;
        } else {
          return element;
        }
      });
  }

  identifyWatchlistElement(index, previewElement: WatchlistPreviewElement) {
    return previewElement.uuid || index;
  }
}
